import { PageModuleConfig } from "@openreply/loader-remote-module-config-vite-plugin";

// Static, default Care Calendar Widget
export const defaultWidgetConfig: PageModuleConfig = {
  includeType: "page",
  module: "care-calendar-default-widget",
  customElement: "hobi-content-care-default-widget",
  pages: ["/$", "(.*/)customer-center/dashboard(.*)"],
};

// Regular Care Calendar Widget
export const widgetConfig: PageModuleConfig = {
  includeType: "page",
  module: "care-calendar-widget",
  customElement: "hobi-content-care-calendar",
  pages: ["/$", "(.*/)customer-center/dashboard(.*)"],
};
